import { render, staticRenderFns } from "./not-found.vue?vue&type=template&id=3e9f816c&scoped=true&"
var script = {}
import style0 from "./not-found.scss?vue&type=style&index=0&id=3e9f816c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9f816c",
  null
  
)

export default component.exports